// const zoom = require('zoom-image');

function fancyboxContent () {
  CONFIG.fancybox && NexT.utils.wrapImageWithFancyBox();
}

module.exports = fancyboxContent;
